import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import Button from 'app/components/ButtonDefault'
import cn from 'classnames'

import PlusSVG from '../SVGS/Plus'
import './styles.scss'

const bc = 'empty-block'

const EmptyBlock = ({
  onAdd,
  title,
  btnText,
  className,
  children,
  stretch,
  isShowSubmitButton,
  handleSubmit,
  isDisabledBtnText,
  submitBtnText,
  ...rest
}) => (
  <div
    className={cn(bc, className, {
      [`${bc}__stretch`]: stretch,
    })}
    {...rest}
  >
    <PlusSVG />
    <div className={`${bc}__text`}>{title}</div>
    <div>
      {children || (
        <Fragment>
          <Button xs onClick={() => onAdd()}>
            {btnText}
          </Button>
          {isShowSubmitButton && (
            <Button primary onClick={() => handleSubmit()} disabled={isDisabledBtnText}>
              {submitBtnText}
            </Button>
          )}
        </Fragment>
      )}
    </div>
  </div>
)

EmptyBlock.propTypes = {
  onAdd: PropTypes.func,
  title: PropTypes.string.isRequired,
  btnText: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  stretch: PropTypes.bool,
  handleSubmit: PropTypes.func,
  isShowSubmitButton: PropTypes.bool,
  isDisabledBtnText: PropTypes.bool,
  submitBtnText: PropTypes.string,
}

export default EmptyBlock
